/**
 * patrol-non-search-view.js
 */

import React from 'react';
import IconSection from 'components/icon-section';
import InfoRow from 'components/info-row';
import PatrolArrestsBitesView from '../../helpers/patrol-arrests-bites-view';


export default function PatrolNonSearchView(props) {
  const { 
    deployment,
    record,
  } = props;

  return (
    <>      
      <IconSection iconName='patrol-non-search'>

        {/* warrant types */}
        <InfoRow
          title="Warrant Types"
          text={record.nonSearch.types.length === 0
            ? 'None'
            : record.nonSearch.types.map(type => type.customOtherName || type.name).join(', ')}
        />

      </IconSection>

      <PatrolArrestsBitesView
        deployment={deployment}
        record={record}
      />
    </>
  );
}